import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { HelmetProvider } from "react-helmet-async";
import { APP_STORAGE_VERSION, APP_STORAGE_VERSION_KEY } from "./api/ApiConst";

if (localStorage.getItem(APP_STORAGE_VERSION_KEY) !== APP_STORAGE_VERSION) {
  localStorage.clear();
  try {
    sessionStorage.clear();
  } catch (e) {}

  if ("caches" in window) {
    caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
  }

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
  }

  localStorage.setItem(APP_STORAGE_VERSION_KEY, APP_STORAGE_VERSION);
  if (!sessionStorage.getItem("app_hard_reloaded")) {
    sessionStorage.setItem("app_hard_reloaded", "1");
    window.location.reload(true);
  }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
